<template>
  <div
    class="flex flex-col items-center bg-white rounded shadow-lg h-full pl-4 pr-4 pt-4"
  >
    <!-- Create Mode -->
    <div v-if="mode === 'create'">
      <div v-if="authType">
        <rele-hubspot-auth
          :auth-type="authType"
          :mode="mode"
          @close="$emit('close')"
        />
      </div>
      <div v-else class="mb-10 md:mt-0 mt-10">
        <!-- title -->
        <div class="font-bold w-full ml-2">
          {{ $t("integrations.crm.hubspot.chooseAuth.title") }}
        </div>
        <!-- Description -->
        <!-- Which auth to choose description -->
        <div class="mt-5 mb-1 ml-10 mr-10">
          {{ $t("integrations.crm.hubspot.chooseAuth.chooseAuthMethodTitle") }}
        </div>

        <!-- Choose api key title -->
        <div class="flex flex-row mt-3">
          <div class="relative">
            <rele-info-tooltip
              class="absolute bottom-0 ml-10"
              style="right: -40%; z-index: 10"
              :tooltipStyle="{ right: '-750%' }"
              icon="info"
              :tooltip-html="
                $t('integrations.crm.hubspot.chooseAuth.tooltips.apiKey')
              "
            />
            <div class="ml-10 font-bold underline mt-3 w-auto">
              {{ $t("integrations.crm.hubspot.chooseAuth.apiKey") }}
            </div>
          </div>
        </div>

        <!-- Choose api key description -->
        <div
          class="ml-10 mr-10 mt-2"
          v-html="
            $t('integrations.crm.hubspot.chooseAuth.chooseAuthApiKeyDesc')
          "
        />

        <!-- Choose oauth title -->
        <div class="flex flex-row mt-3">
          <div class="relative">
            <rele-info-tooltip
              class="absolute bottom-0 ml-10"
              style="right: -20%; z-index: 8"
              :tooltipStyle="{ right: '-450%' }"
              icon="info"
              :tooltip-html="
                $t('integrations.crm.hubspot.chooseAuth.tooltips.oauth')
              "
            />
            <div class="ml-10 font-bold underline mt-3 w-auto">
              {{ $t("integrations.crm.hubspot.chooseAuth.oauth") }}
            </div>
          </div>
        </div>

        <!-- Choose oauth description -->
        <div
          class="ml-10 mr-10 mt-2"
          v-html="$t('integrations.crm.hubspot.chooseAuth.chooseAuthOauthDesc')"
        />

        <!-- Icons -->
        <div class="flex flex-row justify-center md:mb-10 mb-20 mt-5">
          <div
            class="m-4 border border-solid rounded-lg hover:bg-r-secondary hover:bg-opacity-25 cursor-pointer w-40"
            @click="onApiKeyClick"
          >
            <img src="@/assets/icons/key.png" class="w-20 m-8" />
            <div class="text-center font-bold mb-2">
              <div class="ml-8 mr-8">
                {{ $t("integrations.crm.hubspot.chooseAuth.apiKey") }}
              </div>
            </div>
          </div>
          <div
            class="flex flex-col items-center m-4 border border-solid rounded-lg hover:bg-r-secondary hover:bg-opacity-25 cursor-pointer w-40"
            @click="onOauthClick"
          >
            <img src="@/assets/icons/oauth.png" class="w-20 m-8" />
            <div class="text-center font-bold mb-2">
              <div class="ml-5 mr-5">
                {{ $t("integrations.crm.hubspot.chooseAuth.oauth") }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- Edit mode -->
    <div v-else>
      <rele-hubspot-auth
        :auth-type="authType"
        :mode="mode"
        @close="$emit('close')"
      />
    </div>
    <!-- Close button visible on mobile only -->
    <div v-if="authType !== 'apiKey'" class="md:hidden relative w-full">
      <r-button
        class="absolute bottom-0 right-0"
        color="black"
        text
        @click="$emit('close')"
      >
        {{ $t("buttons.close") }}
      </r-button>
    </div>
  </div>
</template>

<script>
// import { mapGetters } from "vuex"

export default {
  // define props
  props: {
    mode: {
      type: String,
      required: true
    },
    authType: {
      type: String,
      default: ""
    }
  },

  // computed property
  computed: {
    /**
     * returns the tooltipStyle style
     */
    tooltipStyle() {
      return { right: "-700%" }
    }
  },

  // methods
  methods: {
    /**
     * On Api key choose
     */
    onApiKeyClick() {
      this.$emit("on-api-key-choice")
    },

    /**
     * On Oauth
     */
    onOauthClick() {
      this.$emit("on-oauth-choice")
    },

    /**
     * On dialog close
     */
    onDialogClose() {
      this.$emit("close")
    }
  }
}
</script>
